import {ref, computed} from 'vue';
import {defineStore} from 'pinia';
import {useErrorHandler} from '@malt/utils';
import {Configuration, ProfileSuggestionsApi, type FetchError, type ProfileSuggestion} from '@api';

export const useProfileSuggestionsStore = defineStore('profile-suggestions', () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const profileSuggestionsApi = new ProfileSuggestionsApi(apiConfiguration);
    const {handleFetchError} = useErrorHandler();

    const suggestions = ref<ProfileSuggestion[]>([]);
    const hasSuggestions = computed(() => suggestions.value.length > 0);

    async function getSuggestions(): Promise<void> {
        try {
            const result = await profileSuggestionsApi.getProfileSuggestions();
            suggestions.value = result.suggestions;
        } catch (e) {
            handleFetchError(e as FetchError);
        }
    }

    return {suggestions, hasSuggestions, getSuggestions};
});
